/**
 * TanStack Query hooks for `top-advertisers-widget`. Thin wrappers over ./api.
 */
import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import {
	list,
	topAdvertisersWidgetQueryKeys,
	type ListTopAdvertisersWidgetParams,
	type ListTopAdvertisersWidgetResponse,
} from "./api";

export function useTopAdvertisersWidgetList(
	params: ListTopAdvertisersWidgetParams = {},
): UseQueryResult<ListTopAdvertisersWidgetResponse, Error> {
	return useQuery({
		queryKey: topAdvertisersWidgetQueryKeys.list(params),
		queryFn: () => list(params),
	});
}
